import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { getDayOfCurrentWeek, getTodayDate } from '@app/utils/date'
import { dateFormat } from '@app/constants'

import type { FiltersParams } from '@app/types/filter'

export const getDefaultWeekPeriod = (dateAtAfterKey?: string, dateAtBeforeKey?: string): FiltersParams => {
  const currentDateAtAfterKey = dateAtAfterKey ?? FILTERS_PARAMS_KEYS.createdAtAfter
  const currentDateAtBeforeKey = dateAtBeforeKey ?? FILTERS_PARAMS_KEYS.createdAtAfter

  return {
    [currentDateAtAfterKey]: null,
    [currentDateAtBeforeKey]: null,
    [FILTERS_PARAMS_KEYS.week]: getTodayDate().week().toString()
  }
}

export const getDefaultDatePeriod = (dateAtAfterKey?: string, dateAtBeforeKey?: string): FiltersParams => {
  const currentDateAtAfterKey = dateAtAfterKey ?? FILTERS_PARAMS_KEYS.createdAtAfter
  const currentDateAtBeforeKey = dateAtBeforeKey ?? FILTERS_PARAMS_KEYS.createdAtAfter

  return {
    [currentDateAtAfterKey]: getDayOfCurrentWeek(1).format(dateFormat.YYYY_MM_DD),
    [currentDateAtBeforeKey]: getDayOfCurrentWeek(7).format(dateFormat.YYYY_MM_DD),
    [FILTERS_PARAMS_KEYS.week]: null
  }
}
